import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AccountService } from './api/account.service';
import { AppSettingService } from './api/appSetting.service';
import { AuditTrailService } from './api/auditTrail.service';
import { AuthenticationService } from './api/authentication.service';
import { BarcodeImageService } from './api/barcodeImage.service';
import { BarcodeTesterService } from './api/barcodeTester.service';
import { CustomerService } from './api/customer.service';
import { CustomerClassService } from './api/customerClass.service';
import { CustomerOrderService } from './api/customerOrder.service';
import { DashboardService } from './api/dashboard.service';
import { DimensionService } from './api/dimension.service';
import { DocumentNumberSettingService } from './api/documentNumberSetting.service';
import { DocumentTypeService } from './api/documentType.service';
import { GPItemClassService } from './api/gPItemClass.service';
import { GPSalesTypeService } from './api/gPSalesType.service';
import { GPSiteService } from './api/gPSite.service';
import { GPUserService } from './api/gPUser.service';
import { HelpService } from './api/help.service';
import { HelpCategoryService } from './api/helpCategory.service';
import { HelpTopicService } from './api/helpTopic.service';
import { InternalTransferService } from './api/internalTransfer.service';
import { InvTranService } from './api/invTran.service';
import { InvTranTypeService } from './api/invTranType.service';
import { InventoryCountingService } from './api/inventoryCounting.service';
import { InventoryCountingRevisionService } from './api/inventoryCountingRevision.service';
import { ItemService } from './api/item.service';
import { ItemExternalUPCService } from './api/itemExternalUPC.service';
import { ItemSettingService } from './api/itemSetting.service';
import { LabelTemplateService } from './api/labelTemplate.service';
import { LabelTransactionService } from './api/labelTransaction.service';
import { LocationService } from './api/location.service';
import { LocationSettingService } from './api/locationSetting.service';
import { LocationSiteService } from './api/locationSite.service';
import { PermissionService } from './api/permission.service';
import { PriceListService } from './api/priceList.service';
import { PrinterDeviceAssignmentService } from './api/printerDeviceAssignment.service';
import { ProductRepositoryService } from './api/productRepository.service';
import { RoleService } from './api/role.service';
import { RolePermissionService } from './api/rolePermission.service';
import { ScanDocumentService } from './api/scanDocument.service';
import { ScanDocumentTypeService } from './api/scanDocumentType.service';
import { SiteService } from './api/site.service';
import { TaskProcessService } from './api/taskProcess.service';
import { TimeZoneService } from './api/timeZone.service';
import { TraceabilityManagementService } from './api/traceabilityManagement.service';
import { TransferInventoryService } from './api/transferInventory.service';
import { UserService } from './api/user.service';
import { UserSettingService } from './api/userSetting.service';
import { UtilHelperService } from './api/utilHelper.service';
import { VendorClassService } from './api/vendorClass.service';
import { WebReportingService } from './api/webReporting.service';
import { WorkflowSatusService } from './api/workflowSatus.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
